"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLayoutNav = void 0;
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _composeStencilComponent = require("../../utils/composeStencilComponent");
var _Row = _interopRequireDefault(require("../Row"));
var _helperComponents = require("./helperComponents");
var _react2 = require("@emotion/react");
const AppLayoutNavBase = _ref => {
  let {
    children,
    ...wrapperProps
  } = _ref;
  return (0, _react2.jsx)(_helperComponents.ContentWrapper, {
    contentProps: {
      flexDirection: 'column'
    },
    wrapperProps: wrapperProps
  }, children);
};
const AppLayoutNav = exports.AppLayoutNav = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: AppLayoutNavBase,
  displayName: 'AppLayoutNav',
  description: 'Navigational element to wrap components like SecondaryNav, Breadcrumbs, ProgressTracker etc.',
  propTypes: {
    children: _stencilReactDesc.PropTypes.node,
    ..._Row.default.describedPropTypes
  }
});